// Every article that should appear on /blogs, newest first.
//
// These are hand-built article pages with their own routes (not Strapi
// entries), so adding a new one is a matter of shipping the page and adding a
// row here. `cover` is optional: without one the card falls back to the
// gradient panel with the Zero Typing mark centred in it.
import howVoiceTypingWorksCover from "../HowVoicetypingWorks/Assets/image.png";
import voicePromptingAiCover from "../DictatingAiPrompts/Assets/image.png";

export const BLOG_POSTS = [
  {
    id: "voice-prompting-ai",
    title: " Guide to Dictate Better AI Prompts",
    excerpt:
      "The best AI prompts are long, specific, and detailed — exactly the kind of thing that's slow to type and fast to say.",
    path: "/voice-prompting-ai",
    cover: voicePromptingAiCover,
  },
  {
    id: "how-ai-voice-typing-works",
    title: "How AI Voice Typing Actually Works",
    excerpt:
      "If you've ever spoken into a microphone and watched your words appear as a polished paragraph on your screen.",
    path: "/how-ai-voice-typing-works",
    cover: howVoiceTypingWorksCover,
  },
];
